import {
   AfterViewInit,
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   Input,
   OnInit,
   ViewChild
} from '@angular/core';
import {PositionsSectionModel} from './model/PositionsSectionModel';
import {ApgAfterStatePreviewComponent} from '../after-state-preview/apg-after-state-preview.component';
import {ApgTrackingDialogComponent} from './tracking-dialog/apg-tracking-dialog.component';
import {ApgContextMenuComponent} from "../context-menu/apg-context-menu.component";
import {DxNumberBoxComponent} from "devextreme-angular/ui/number-box";
import {CashFlowStrategyRole} from "../../shell-communication/shell-dto-protocol";
import {PositionsDefaultSettings} from "../services/positions-before-state.service";
import {DetectMethodChanges, isVoid} from "../../utils";
import {
   GenericConfirmationDialogComponent
} from "../../generic-confirmation-dialog/generic-confirmation-dialog.component";
import {AdjustmentPricingGridComponent} from "../adjustment-pricing-grid.component";

@Component({
   selector: 'ets-adjustment-pricing-grid-positions-section',
   templateUrl: './adjustment-pricing-grid-positions-section.component.html',
   styleUrls: [
      './adjustment-pricing-grid-positions-section.component.scss',
      '../adjustment-grid-common-style.scss',
   ]
})
export class AdjustmentPricingGridPositionsSectionComponent implements OnInit, AfterViewInit {
   constructor(
       private readonly _changeDetector: ChangeDetectorRef
   ) { }


   @Input()
   viewModel: PositionsSectionModel;


   @Input()
   orientation: 'left' | 'right';


   @ViewChild(ApgAfterStatePreviewComponent)
   afterStatePreview: ApgAfterStatePreviewComponent;


   @ViewChild(ApgTrackingDialogComponent)
   trackingDialog: ApgTrackingDialogComponent;


   @ViewChild('ctxMenu')
   ctxMenu: ApgContextMenuComponent;

   @ViewChild('manualDistanceInput', {static: false})
   manualDistanceInput: DxNumberBoxComponent;

   @ViewChild(GenericConfirmationDialogComponent)
   confirmationDialog: GenericConfirmationDialogComponent;

   @Input() context!: AdjustmentPricingGridComponent;

   get afterStatesCount(): number {
      const count = (this.viewModel.hasAfterStateFirst ? 1 : 0)
          + (this.viewModel.hasAfterStateSecond ? 1 : 0);

      return count;
   }

   ngOnInit(): void { }


   ngAfterViewInit(): void {
      this.viewModel.orientation = this.orientation;
      this.viewModel.afterStatePreview = this.afterStatePreview;
      this.viewModel.trackingDialog = this.trackingDialog;
      this.viewModel.ctxMenu = this.ctxMenu;
      this.viewModel.manualDistanceInput = this.manualDistanceInput;
   }

   canSetRollXDaysAfterShorts(leg: CashFlowStrategyRole, settings: PositionsDefaultSettings) {
      if (leg === 'ProtectiveOption') {
         return isVoid(settings.protectiveOptionDaysToExpiration);
      } else if (leg === 'SecondProtectiveOption') {
         return isVoid(settings.secondProtectiveOptionDaysToExpiration);
      }
   }

   canSetOptionDaysToExpiration(leg: CashFlowStrategyRole, settings: PositionsDefaultSettings) {
      if (leg === 'ProtectiveOption') {
         return isVoid(settings.protectiveOptionRollXDaysAfterShorts);
      } else if (leg === 'SecondProtectiveOption') {
         return isVoid(settings.secondProtectiveOptionRollXDaysAfterShorts);
      }
   }

   @DetectMethodChanges()
   onChange() {

   }

   async clearSavedAdjustment(side?: 'Calls' | 'Puts' | 'All') {

      let sideText = 'All';

      if (!isVoid(side)) {
         sideText = side.toLowerCase();
      } else {
         if (this.viewModel.hasAfterStateFirst) {
            side = 'Calls';
            sideText = 'calls';
         } else {
            side = 'Puts';
            sideText = 'puts';
         }
      }

      try {
         await this.confirmationDialog.show([
            `Are you sure you want to clear ${sideText}`,
            'saved adjustments?'
         ]);
         this.viewModel.clearSavedAdjustment(side);
      } catch {
         return;
      }
   }

   async fullReset() {
      try {
         await this.confirmationDialog.show([
            'Are you sure you want to reset',
            'positions to default settings?'
         ]);
         await this.viewModel.fullReset();
      } catch {
         return;
      }
   }
}
